import { generateSectionMenus } from 'layouts/menuItems';
import { SectionStubDto } from 'models/dtoTypes';

export default function generateSmeMenuList(sections: SectionStubDto[]) {
  return [
    {
      label: 'Company details',
      icon: 'CompanySvg',
      path: '/questionnaire',
      subItems: generateSectionMenus(sections)
    },
    {
      label: 'ESG Ratings',
      path: '/esg-ratings',
      icon: 'FinanceSvg'
    },
  ];
}
